const IconPhone = ({ stroke, size, ...rest }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 64 64"
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      stroke={stroke}
      strokeWidth={2}
      {...rest}
    >
      <path d="M24 56a4 4 0 0 0 4-4v-4a4 4 0 0 0-4-4c-8 0-8-8-8-12s0-12 8-12a4 4 0 0 0 4-4v-4a4 4 0 0 0-4-4C14 8 8 12 8 32s6 24 16 24z" />
      <path d="M47.4 52a27.33 27.33 0 0 0 0-38.63" />
      <path d="M39.67 44.27a16.38 16.38 0 0 0 0-23.17" />
      <path d="M32 36.55a5.47 5.47 0 0 0 0-7.73" />
    </svg>
  );
};

export const PhoneIcon = (props) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M5.82888 14.171C3.67828 12.0163 2.02439 9.41767 0.982877 6.55702C0.409877 4.99302 0.934877 3.27502 2.11288 2.09702L2.84188 1.36902C3.03786 1.17264 3.27066 1.01684 3.52693 0.910534C3.78321 0.80423 4.05793 0.749512 4.33538 0.749512C4.61282 0.749512 4.88755 0.80423 5.14382 0.910534C5.4001 1.01684 5.63289 1.17264 5.82888 1.36902L7.53588 3.07602C7.73226 3.27201 7.88806 3.5048 7.99437 3.76108C8.10067 4.01735 8.15539 4.29208 8.15539 4.56952C8.15539 4.84697 8.10067 5.12169 7.99437 5.37797C7.88806 5.63424 7.73226 5.86704 7.53588 6.06302L7.11588 6.48302C6.94776 6.6511 6.8144 6.85065 6.72342 7.07028C6.63243 7.2899 6.5856 7.5253 6.5856 7.76302C6.5856 8.00075 6.63243 8.23615 6.72342 8.45577C6.8144 8.67539 6.94776 8.87494 7.11588 9.04302L10.9559 12.884C11.124 13.0521 11.3235 13.1855 11.5431 13.2765C11.7628 13.3675 11.9982 13.4143 12.2359 13.4143C12.4736 13.4143 12.709 13.3675 12.9286 13.2765C13.1482 13.1855 13.3478 13.0521 13.5159 12.884L13.9369 12.464C14.1329 12.2676 14.3657 12.1118 14.6219 12.0055C14.8782 11.8992 15.1529 11.8445 15.4304 11.8445C15.7078 11.8445 15.9825 11.8992 16.2388 12.0055C16.4951 12.1118 16.7279 12.2676 16.9239 12.464L18.6309 14.171C18.8273 14.367 18.9831 14.5998 19.0894 14.8561C19.1957 15.1124 19.2504 15.3871 19.2504 15.6645C19.2504 15.942 19.1957 16.2167 19.0894 16.473C18.9831 16.7292 18.8273 16.962 18.6309 17.158L17.9029 17.886C16.7249 19.065 15.0069 19.59 13.4429 19.017C10.5822 17.9755 7.98364 16.3216 5.82888 14.171Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default IconPhone;
